import { useRef } from 'react'

export const useLatestValue = <T>(value: T) => {
    const valueRef = useRef(value)
    valueRef.current = value

    return valueRef
}
